import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, MarqueeComponentHomePage, TransparentCustomButton} from '@/components/qbStrap';
import Image from 'next/image';
import { ClientsArr1, testimonialData, videoTestimonial, getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopMosambee = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    const Features = [
        {
            id: 1,
            image: "/assets/MosambeePayments/payment.svg",
            title: "Flexible Payment Options ",
            desc: "Offer a seamless checkout experience by providing your customers with a variety of payment methods. From traditional card payments to modern digital wallets, Mosambee Payment Gateway ensures that customers can pay in the way that suits them best, enhancing their experience and boosting sales.",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            imageWidth: "40rem",
            tagColor: "#C9F6FF",
            points: [
                "Accepts payments via credit/debit cards, UPI, and mobile wallets.",
                "Supports international cards, expanding your customer base.",
               " Ensures quick and contactless payments for faster transactions."
            ]
        },
        {
            id: 2,
            image: "/assets/MosambeePayments/transaction.svg",
            title: "Transaction Processing and Reporting",
            desc: "Stay ahead of the curve with real-time transaction processing. Every sale, refund, or update is reflected instantly in your QueueBuster POS, allowing you to monitor business activity in real time. This provides valuable insights into your daily operations and helps you make data-driven decisions.",
            bgColor: "#F2FDEB",
            imageHeight: "32rem",
            mobImageHeight: "16rem",
            btnText: "Request a callback",
            tagColor: "#d4f4bf",
            points: [
                "Immediate synchronization of transactions for all payment types.",
                "Access detailed reports on sales, refunds, and revenue anytime.",
               " Maintain accuracy across multiple locations with real-time updates.",
            ]
               
        },
        {
            id: 3,
            image: "/assets/MosambeePayments/refund.svg",
            title: "Refund and Dispute Resolution",
            desc: "Simplify the refund and dispute process with Mosambee Payment Gateway integrated into QueueBuster POS. Refunds are processed quickly, ensuring that customers stay satisfied, while disputes can be managed directly through the system, making the process transparent and easy to control.",
            bgColor: "#FCF7FF",
            imageHeight: "44rem",
            mobImageHeight: "22rem",
            btnText: "Talk to an expert",
            tagColor: "#e6ccf6",
            points: [
               "Process refunds instantly through the POS system.",
               " Track refund status in real time, minimizing customer follow-ups.",
               "Built-in tools for handling disputes and chargebacks efficiently.",
            ]
        },
        {
            id: 4,
            image: "/assets/MosambeePayments/offline.svg",
            title: "Offline Payment Processing",
            desc: "Don’t let internet issues slow down your business. With Mosambee Payment Gateway’s offline payment processing, you can continue accepting payments even when the connection is down. Transactions are securely stored offline and processed as soon as the system is back online, ensuring a seamless experience for you and your customers.",
            bgColor: "#8ae4f626",
            imageHeight: "42rem",
            mobImageHeight: "20rem",
            btnText: "Speak with an expert",
            tagColor: "#C9F6FF",
            points: [
                "Mosambee can accept payments offline if the payment request was received before internet access is lost.", 
                "Continue processing all payment types without interruptions.",
                "Avoid revenue loss and maintain smooth operations during downtime.",
            ]
        },
    ]

    const FAQ = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is Mosambee Payment Gateway and how does it integrate with QueueBuster POS?
                </span>
            ),
            des: "Mosambee Payment Gateway empowers a complete end-to-end payment processing gateway for a wide variety of payment types, including credit/debit cards, UPI, and mobile wallets. The QueueBuster POS integration with this gateway allows all businesses to process transactions in an orderly manner through one system. This also makes QueueBuster POS so much more efficient by giving a seamless checkout experience, real updates about every transaction, and handling of refunds and disputes smoothly.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are the various payment methods Mosambee Payment Gateway supports when integrated with QueueBuster POS?
                </span>
            ),
            des: [ 
                <div>
                <p>Mosambee Payment Gateway offers a wide range of payment options for customers to choose from. Specifically, it includes:</p>
                <ul>
                    <li><b>Credit and Debit Cards:</b> Major cards such as Visa, MasterCard, and American Express.</li>
                    <li><b>UPI (Unified Payments Interface):</b> Seamless and swift payments through UPI platforms.</li>
                    <li><b>Mobile Wallets:</b> Seamlessly pay by using digital wallets on Paytm, Google Pay, and PhonePe.</li>
                    <li><b>Net Banking:</b> Direct bank transfers to provide more avenues for making payments.</li>
                </ul>
            </div>
            ],
            
             
            
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does real-time transaction processing help my business by Mosambee Payment Gateway?
                </span>
            ),
            des: [ 
                <div>
                <p>The real-time transaction processing with Mosambee Payment Gateway updates every transaction live in QueueBuster POS. Which means: </p>
                <ul>
                    <li><b>Better Decision Making: </b>Realtime sales and revenue reporting give you valuable insights that are invaluable to making better decisions for your business.</li>
                    <li><b>Accurate Data Maintenance:</b>   Changes take place real time across all locations so that your financial reporting remains consistent and accurate.</li>
                </ul>
            </div>
            ],
              id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     What is the functionality provided by Mosambee Payment Gateway for refund and dispute processing?
                </span>
            ),
            des:[
                <div>
                    <p>Manage refunds and disputes with the following strong features of Mosambee Payment Gateway integrated with QueueBuster POS:</p>
                    <ul>
                        <li><b>Instant Refund Processing:</b> The refund initiation can be done directly from the POS system, hence smoothing the process for both staff and customers.</li>
                        <li> <b>RealTime Tracking:</b> It provides real-time tracking of refunds, which manages customer expectations and reduces follow-up queries.</li>
                        <li><b>Chargeback/Dispute Resolution Tool:</b> Inbuilt chargeback and dispute handling tools in a structured manner for smooth resolution.</li>
                    </ul>
                </div>
            ],
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the Mosambee Payment Gateway provide for offline payment processing?
                </span>
            ),
            des: [
                <div>
                    <p>The Mosambee Payment Gateway allows for offline payment processing to maintain continuity of service. In the event of unavailability of internet connectivity:</p>
                    <ul>
                        <li> <b>Storing Data at Local Level:</b> It gets stored on the device itself till connectivity resumes.</li>
                        <li><b>Autosync:</b> The offline transaction gets processed and synced automatically when the connectivity gets re-established.</li>
                        <li><b>Operate Continuously:</b> This allows you to keep receiving payments without a break, enabling minimal loss of revenue on your account.</li>
                        </ul>
                </div>
            ], 
             id: 5,
            activeIndex: 0,
        },

        {
            para: (
                <span style={{ width: "90%" }}>
                   Will transactions made through Mosambee Payment Gateway be secure?
                </span>
            ),
            des: [
                <div>
                    <p>Mosambee Payment Gateway is designed with the highest standards of security to protect your transactions and your customer information. it ensures:</p>
                     <ul>
                        <li><b>Data Encryption:</b> Payment information would be encrypted during the process of transmission.</li>
                        <li><b>Fraud Protection:</b> The transactions would be monitored for suspicious activities using advanced fraud detection tools.</li>
                        <li><b>Secure Data Storage:</b> The sensitive information will be kept securely to avoid unauthorized access.</li>
                     </ul>
              
                </div>
            ],
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does the integration handle multistore transactions?
                </span>
            ),
            des: [
                <div>
                    <p>Upon integrating Mosambee Payment Gateway with QueueBuster POS, the system represents a single dashboard for multilocation transaction handling. This consists of:</p>
                    <ul>
                        <li><b>Centralized Reporting:</b> Represent reports for sales, revenue, and refunds for all outlets on a single dashboard.</li>
                        <li> <b>Realtime Synchronization:</b> Data of the transaction gets updated in real-time, and consistency is maintained across many stores.</li>
                        <li><b>Easy Management:</b> The system makes it easier to manage the financial data as well as the operational performance of the outlet performance.</li>
                    </ul>

                     
 
                </div>
            ],
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do I set up Mosambee Payment Gateway in QueueBuster POS?
                </span>
            ),
            des: [
                <div>
                    <p>Setting up the Mosambee Payment Gateway in QueueBuster POS is pretty easy. Steps generally involve:</p>
                    <ul>
                        <li> <b>Mode of Configuration:</b> One can integrate Mosambee Payment Gateway with QueueBuster POS by using the Setup Wizard or Configuration mode.</li>
                        <li><b>Testing:</b> Test transactions should be performed so that everything goes fine.</li>
                        <li> <b>Training:</b> Training for the staff can also be given so that it's smoothly shifted towards the new payment features.</li>
                        <li> <b>Support:</b>  Customer support for fixing any glitch in installing the system or any doubts.</li>
                    </ul>
                </div>
            ],
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I customize the payment options offered to customers using Mosambee Payment Gateway?
                </span>
            ),
            des: "Yes, QueueBuster POS permits you to configure payment options available through Mosambee Payment Gateway. On this page, you can enable or disable different kinds of payments such as Credit Cards, UPI, and Wallets according to your requirements. You are allowed to set general defaults for your business needs regarding the payment methods. You can update the options related to payments anytime when your customers' preferences change over time or when new technologies appear.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does Mosambee Payment Gateway improve the customer experience at checkout? 
                </span>
            ),
            des: [
                <div>
                    <p>The Mosambee Payment Gateway improves the customer experience by offering:</p>
                    <ul>
                        <li> <b>Multiple Payment Options</b>Giving a choice between several types of payments will have them choose their most preferred way.</li>
                        <li><b>Fast Transaction:</b>Saves clients from waiting around checkouts because of its speedy processing or even contactless payments.</li>
                        <li><b>Seamless Experience:</b>The integrated systems guarantee that each transaction is smooth and error-free, which in turn contributes to satisfaction overall and encourages repeat customers.</li>
                    </ul>
                </div>
            ],
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/MosambeePayments/Icons_Mosambee.svg" alt="Mosambee" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Mosambee Payment Integration</span><br />
                        <span className={styles.black_text}>with</span><span className={styles.blue_text}> QueueBuster POS</span>
                    </h1>
                    <p className={styles.page_desc}>Take your business transactions to the next level with the Mosambee Payment Gateway, seamlessly integrated into QueueBuster POS. Whether you run a retail store, café, or any other enterprise, this solution empowers you with multiple payment options, real-time transaction updates, hassle-free refunds, and the ability to keep operations going even offline.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "40rem" }}><Image src="/assets/MosambeePayments/Mosambee-Desktop.svg" alt="Mosambee" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3> Advanced Features of Mosambee Payment Gateway with QueueBuster POS</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                <HardwareFeatures features={Features} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={FAQ} heading={"FAQs for QueueBuster POS Integrated Mosambee Payment Gateway"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopMosambee



 